import React, { useCallback } from 'react';
import { block } from 'bem-cn';
import { useSelector } from 'react-redux';

import Input from 'components/Input';
import InputDate from 'components/InputDate/desktop';
import SVG from 'components/SVG';
import Button from 'components/Button/Button';
import CheckBox from 'components/CheckBox';

import useTree from 'hooks/useTree';

import searchSvg from './img/search.svg';

import './UsersFilterBlock.scss';

const b = block('users-filter-block');
const UsersFilterBlock = ({
  filterValue,
  changeFilterValue,
  date,
  onChangeBeginDate,
  onChangeEndDate,
  onResetFilter,
  callBack = null,
  actionProcessing,
  placeholder = null,
  isDirectStructure,
  onChangeDirectStructure,
}) => {
  const locale = useSelector(state => state.locale.locale);
  const { getTreeById } = useTree();

  const activeCallback = () => {
    if (callBack) return callBack();
    return getTreeById(filterValue || '');
  };

  const onButtonClick = useCallback(
    props => {
      if (props) {
        switch (props.type) {
          case 'keydown':
            if (props?.event.key === 'Enter') activeCallback();
            break;
          default:
            return null;
        }
      }
    },
    [filterValue],
  );

  return (
    <div className={b()}>
      <div className={b('date-inputs')}>
        <div className={b('item')}>
          <div className={b('title')}>{locale.dateFrom}</div>
          <div className={b('input')}>
            <InputDate selected={date.beginDate} onChange={onChangeBeginDate} />
          </div>
        </div>
        <div className={b('item')}>
          <div className={b('title')}>{locale.dateUntil}</div>
          <div className={b('input')}>
            <InputDate selected={date.endDate} onChange={onChangeEndDate} />
          </div>
        </div>
      </div>
      <div className={b('item')}>
        {/* <div className={b('title')}>{locale.player_agent}</div> */}
        <div className={b('input')}>
          <Input
            onKeyDown={event => onButtonClick({ event, type: 'keydown' })}
            value={filterValue}
            callBack={changeFilterValue}
            placeholder={placeholder ?? locale.login}
            color="transparent"
          />
        </div>
        {/* <div className={b('description')}>({locale.typeOnlyLowercase})</div> */}
      </div>
      <div className={b('search')} onClick={callBack}>
        <SVG className={b('search-icon')} svgProps={{ svg: searchSvg }} />
      </div>
      {/* <div className={b('item')}>
        <div className={b('title')}>{locale.dateFrom}</div>
        <div className={b('input')}>
          <InputDate selected={date.beginDate} onChange={onChangeBeginDate} />
        </div>
      </div>
      <div className={b('item')}>
        <div className={b('title')}>{locale.dateTo}</div>
        <div className={b('input')}>
          <InputDate selected={date.endDate} onChange={onChangeEndDate} />
        </div>
      </div>
      <div className={b('item')}>
        <div className={b('title')}>&nbsp;</div>
        <div className={b('checkbox')}>
          <CheckBox checked={isDirectStructure} onChange={() => onChangeDirectStructure(!isDirectStructure)} />
          <div>{locale.directOnly}</div>
        </div>
      </div>
      <div className={b('item')}>
        <div className={b('title')}>&nbsp;</div>
        <div className={b('button')}>
          <Button text={locale.acceptFilter} callBack={callBack} disabled={actionProcessing} />
        </div>
      </div>
      <div className={b('item')}>
        <div className={b('title')}>&nbsp;</div>
        <div className={b('button')}>
          <Button text={locale.resetFilter} color="transparent" callBack={onResetFilter} />
        </div>
      </div> */}
    </div>
  );
};

export default UsersFilterBlock;
